import qrcode from 'qrcode-generator';

/**
 * Matriz de un código QR (true = módulo oscuro). Corrección de errores media (M): tolera manchas
 * o dobleces en una credencial impresa.
 */
export function qrMatrix(text: string): boolean[][] {
  const qr = qrcode(0, 'M');
  qr.addData(text, 'Byte');
  qr.make();
  const n = qr.getModuleCount();
  return Array.from({ length: n }, (_, r) => Array.from({ length: n }, (_, c) => qr.isDark(r, c)));
}

/** Trazo SVG de los módulos oscuros (un cuadrado de 1×1 por módulo), con margen de 4 módulos. */
export function qrPath(matrix: boolean[][], quiet = 4): string {
  const parts: string[] = [];
  matrix.forEach((row, r) => row.forEach((dark, c) => {
    if (dark) parts.push(`M${c + quiet} ${r + quiet}h1v1h-1z`);
  }));
  return parts.join('');
}
